import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Jeśli zaciągnąłeś kredyt hipoteczny w latach 2022-2023, prawdopodobnie masz oprocentowanie
        w okolicach 8-9%. Tymczasem w 2026 roku, po <BlogLink slug="obnizki-stop-procentowych-2026">obniżkach stóp procentowych</BlogLink>,
        można dostać kredyt już za ~6%. Różnica 2-3 punkty procentowe to tysiące złotych
        miesięcznie. Refinansowanie — czyli "przeniesienie" kredytu do innego banku na lepszych
        warunkach — to właśnie taka okazja. Sprawdź, czy Ci się opłaca.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co to jest refinansowanie?</h2>
      <p>
        Refinansowanie kredytu hipotecznego to zaciągnięcie nowego kredytu w innym banku
        (lub tym samym, na lepszych warunkach) w celu spłaty starego. W praktyce nowy bank
        wypłaca Ci kwotę potrzebną do zamknięcia dotychczasowego zadłużenia, a Ty spłacasz
        dalej ratę, ale na nowych, korzystniejszych warunkach.
      </p>
      <p className="mt-3">
        Typowe powody refinansowania:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Niższe oprocentowanie</strong> — główny powód w 2026 roku</li>
        <li><strong>Niższa marża banku</strong> — zwłaszcza jeśli Twój bank nie chce jej obniżyć w negocjacjach</li>
        <li><strong>Zmiana typu oprocentowania</strong> — przejście ze <BlogLink slug="stale-czy-zmienne-oprocentowanie">stałego na zmienne</BlogLink> (lub odwrotnie)</li>
        <li><strong>Zmiana okresu kredytowania</strong> — wydłużenie dla niższej raty lub skrócenie dla szybszej spłaty</li>
        <li><strong>Konsolidacja zobowiązań</strong> — połączenie kilku kredytów w jeden</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Boom refinansowania w 2026</h2>
      <p>
        Dane Związku Banków Polskich pokazują, że tylko w pierwszym kwartale 2026 roku Polacy
        przenieśli do innych banków <strong>niemal 6 miliardów złotych</strong> kredytów
        hipotecznych. Refinansowanie stanowi już prawie <strong>29% całej sprzedaży kredytów
        mieszkaniowych</strong> — i ten udział rośnie.
      </p>
      <p className="mt-3">
        Dlaczego teraz? Cykl obniżek stóp spowodował, że banki walczą o nowych klientów
        — w tym o kredytobiorców z istniejącymi, wysoko oprocentowanymi kredytami. Oferują
        promocje, niższe marże i uproszczone procedury refinansowania.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Kiedy refinansowanie się opłaca?</h2>
      <p>
        Są trzy kluczowe czynniki, które decydują o opłacalności:
      </p>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <ol className="list-decimal pl-6 space-y-2">
          <li><strong>Różnica w oprocentowaniu</strong> — im większa, tym większa oszczędność. Minimum 0,5-1 p.p., żeby miało sens po odliczeniu kosztów</li>
          <li><strong>Pozostały okres kredytu</strong> — im więcej lat przed Tobą, tym więcej zaoszczędzisz. Poniżej 5 lat do końca — zwykle się nie opłaca</li>
          <li><strong>Kwota pozostałego zadłużenia</strong> — im wyższe saldo, tym większy efekt procentowy</li>
        </ol>
      </div>

      <p className="mt-3">
        <strong>Przykład:</strong> Pozostało Ci 400 000 zł do spłaty, 20 lat, oprocentowanie 8,5%.
        Dzisiaj możesz refinansować za 6,0%. Różnica 2,5 p.p. oznacza:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Obecna rata: ~3 470 zł</li>
        <li>Rata po refinansowaniu: ~2 865 zł</li>
        <li>Miesięczna oszczędność: <strong>~605 zł</strong></li>
        <li>Oszczędność przez pozostałe 20 lat: <strong>~145 000 zł</strong></li>
      </ul>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} loanYears={20} wiborRate={4.0} bankMargin={2.0} section="interest-rate">
          Oblicz ratę przy nowym oprocentowaniu
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jakie są koszty refinansowania?</h2>
      <p>
        Refinansowanie nie jest darmowe. Zanim podpiszesz umowę, doliczy sobie:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Prowizja nowego banku</strong> — 0-2% kwoty kredytu (coraz częściej 0% w promocjach)</li>
        <li><strong>Wycena nieruchomości</strong> — 400-800 zł (rzeczoznawca)</li>
        <li><strong>Opłaty sądowe</strong> — wpis hipoteki do księgi wieczystej, wykreślenie starej: ~400-500 zł</li>
        <li><strong>Podatek PCC</strong> — 19 zł od ustanowienia hipoteki</li>
        <li><strong>Koszty notarialne</strong> — jeśli wymagane</li>
        <li><strong>Wcześniejsza spłata w starym banku</strong> — zwykle 0% po 3 latach od zaciągnięcia, ale sprawdź umowę</li>
      </ul>
      <p className="mt-3">
        Łączne koszty zwykle mieszczą się w przedziale <strong>2 000 - 5 000 zł</strong>.
        Jeśli miesięczna oszczędność wynosi 500 zł, zwrot kosztów następuje po 4-10 miesiącach —
        potem każda kolejna rata to czysty zysk.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak policzyć opłacalność?</h2>
      <p>
        Prosta zasada: oszczędność w ciągu pierwszego roku musi być wyższa niż koszty
        refinansowania. Jeśli tak — warto rozważyć.
      </p>
      <p className="mt-3">
        Kroki:
      </p>
      <ol className="list-decimal pl-6 space-y-2 mt-3">
        <li><strong>Policz obecną ratę</strong> (lub sprawdź w umowie / aplikacji bankowej)</li>
        <li><strong>Zdobądź ofertę z nowego banku</strong> — najlepiej kilka i porównaj je po <BlogLink slug="rrso-kredyt-hipoteczny">RRSO</BlogLink>, nie po samym oprocentowaniu</li>
        <li><strong>Oblicz nową ratę</strong> przy niższym oprocentowaniu</li>
        <li><strong>Oszczędność miesięczna</strong> × 12 miesięcy = oszczędność roczna</li>
        <li><strong>Porównaj z kosztami</strong> refinansowania (zwykle 2-5 tys. zł)</li>
        <li>Jeśli oszczędność &gt; koszty — <strong>opłaca się</strong></li>
      </ol>

      <div className="mt-4">
        <CalculatorLink section="interest-rate">
          Sprawdź swoją nową ratę w kalkulatorze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Kiedy NIE warto refinansować?</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Pozostało Ci mniej niż 5 lat spłaty</strong> — krótki okres nie "zdąży" zwrócić kosztów refinansowania</li>
        <li><strong>Różnica oprocentowania jest niewielka (poniżej 0,5 p.p.)</strong> — oszczędność może nie pokryć kosztów</li>
        <li><strong>Twoja <BlogLink slug="jak-obliczyc-zdolnosc-kredytowa">zdolność kredytowa</BlogLink> się pogorszyła</strong> — nowy bank może zaoferować gorsze warunki niż masz teraz</li>
        <li><strong>Stary bank nalicza wysokie opłaty za wcześniejszą spłatę</strong> — sprawdź umowę przed decyzją</li>
        <li><strong>Planujesz spłacić kredyt w ciągu 1-2 lat</strong> — szybciej zapłacić, niż refinansować</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Alternatywy dla refinansowania</h2>
      <p>
        Zanim zdecydujesz się na refinansowanie, rozważ też:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Renegocjacja warunków</strong> w obecnym banku — bank często woli obniżyć marżę niż stracić klienta. Wystarczy poprosić</li>
        <li><strong><BlogLink slug="nadplata-kredytu-hipotecznego">Nadpłata kredytu</BlogLink></strong> — jeśli masz wolne środki, zamiast refinansować, możesz zmniejszyć saldo. Efekt bywa podobny</li>
        <li><strong>Zmiana typu rat</strong> — przejście z rat równych na malejące w obecnym banku może obniżyć całkowity koszt</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        W 2026 roku refinansowanie kredytu hipotecznego to realna szansa na oszczędność kilkuset
        złotych miesięcznie i kilkudziesięciu tysięcy w długim terminie. Najbardziej opłaca się
        osobom, które zaciągnęły kredyt w 2022-2023 roku na wysokim oprocentowaniu i mają
        przed sobą jeszcze wiele lat spłaty. Zanim zdecydujesz — policz dokładnie oszczędność,
        porównaj z kosztami i koniecznie spróbuj najpierw renegocjować warunki w obecnym banku.
      </p>

      <div className="mt-4">
        <CalculatorLink section="interest-rate">
          Policz ile zaoszczędzisz refinansując
        </CalculatorLink>
      </div>
    </>
  )
}
